import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';

export const StyledMainProduct = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    &.mainPic {
      object-fit: contain;
      width: 74px;
      aspect-ratio: 1 / 1;
      position: relative;
      left: -8px;
    }
  }

  .text {
    max-width: calc(100% - 95px);
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center !important;
    position: relative;
    z-index: 1;
    margin-left: 4px;

    p {
      margin: 0;
      text-align: center;

      &.quantity {
        font-weight: 700;
        background: linear-gradient(
          to bottom,
          rgb(255, 247, 199),
          rgb(226, 182, 109)
        );
        background-clip: text;
        -webkit-background-clip: text;
        -moz-background-clip: text;
        -webkit-text-fill-color: transparent;
        position: relative;

        &:after {
          background: none;
          content: '${(props: any) => CSS.escape(props.title || '')}';
          left: 0;
          top: 0;
          z-index: -1;
          position: absolute;
          text-shadow: 0 2px 0px #000000;
        }
      }

      &.stroked {
        font-weight: 600;
        color: white;
        position: relative;
        text-shadow: 0 2px black;

        &::after {
          content: ' ';
          height: 2px;
          width: 100%;
          background: #d8232a;
          position: absolute;
          left: 0;
          top: 50%;
        }
      }
    }
  }

  @media (width <= ${breakpoints.mobileM}) {
    img {
      &.mainPic {
        width: 70px;
        left: 0;
      }
    }

    .text {
      max-width: calc(100% - 75px);
    }
  }

  @media (width <= ${breakpoints.mobileS}) {
    .mainPic {
      width: 64px !important;
    }
  }
` as any;

export const StyledSubProduct = styled.div`
  margin-right: 4px;
  width: ${(props: any) => (props.isFullWidth ? '100%' : 'auto')};
  display: flex;
  flex-direction: column;
  justify-content: end;

  .content-container {
    display: flex;
    align-items: center;
    width: 100%;

    p {
      padding-left: ${(props: any) => (props.isBadged ? '0' : '6px')};
      margin: 0 0 0 4px;
      font-size: 12px;
      font-weight: 600;
      color: ${(props: any) => props.color};
      padding-right: 6px;

      &.tooltip {
        font-size: 12px;
        font-weight: 400;

        img {
          display: inline;
          height: 8px;
        }
      }
    }
  }

  img {
    aspect-ratio: 1/1;
    object-fit: contain;
  }

  .product-image-container {
    position: relative;
    padding-left: 4px;
    display: flex;
    flex-direction: row;

    .product {
      position: relative;
      z-index: 2;
      height: 38px;
    }

    .badge {
      box-sizing: content-box;
      height: 22px;
      max-width: 20px;
      margin-right: -15px;
      padding-right: 15px;
      padding-left: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      top: 20px;
      z-index: 1;
      transform: translateY(-50%);
      background-image: url('https://media.appcharge.com/defaults/product-badge-huge.png');
      background-size: 100% 100%;

      &.carousel-item {
        color: black;
      }

      h4 {
        position: relative;
        font-size: 14px;
        padding-left: var(--padding-left);
        font-weight: 600;
        margin: auto 0;
        background: -webkit-linear-gradient(
          rgb(255, 247, 199),
          rgb(226, 182, 109)
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

        &:after {
          background: none;
          content: '${(props: any) => CSS.escape(props.badgeText || '')}';
          padding-left: var(--padding-left);
          left: 0;
          top: 0;
          z-index: -1;
          position: absolute;
          text-shadow: 0 1px 0px #000000;
        }
      }
    }

    .tooltip {
      height: 8px;
      width: 8px;
      position: absolute;
      top: 5px;
      right: 32px;
      transform: translateY(-100%);
      z-index: 4;
    }
  }

  @media (min-width: 375px) {
    .product-image-container .tooltip {
      height: 10px;
      width: 10px;
    }
  }
` as any;
